import React from "react";
import { Layout } from "../../layouts/Layout";
import { CHECK_ICON, SERVICES_DETAILS05 } from "../../lib/assets";
import { ServicesDetailsWrapper } from "../../components/ServicesDetails/ServicesDetailsWrapper";
import { BrandSeven } from "../../components/Brand/BrandSeven";
import { ServicesDetailsFaq } from "../../components/ServicesDetails/ServicesDetailsFaq";
import { Link } from "react-router-dom";
const ServicesDetailsPageFive = () => {
  return (
    <Layout footer = {2} breadcrumb={"Services"} title={"Product Certification"}>
      {/* services-details-area */}
      <ServicesDetailsWrapper hideTitle>
        <div className="services-details-wrap">
          <div className="services-details-content">
            <h2 className="title">Ensuring Quality and Compliance for Your Business
            </h2>
            <p>
            
                  In today’s global marketplace, product certification is more than just a stamp of approval—it’s a 
                  critical step in ensuring your product meets the necessary safety, quality, and regulatory standards. 
                  Certification provides assurance to both consumers and regulatory bodies that your product has been
                  tested and validated to meet specific requirements, making it essential for your business’s success 
                  and credibility.

           
                       </p>

            
           
         {/*   <div className="services-details-thumb-two">
              <img src={SERVICES_DETAILS05} alt="" style={{width:"757px", height:"450px", borderRadius:"25%", padding:"10px"}} />
            </div>*/}
            <p>
            As a business consultancy, we specialize in helping companies navigate the complexities of the 
            product certification process. Our expert services enable you to expand into new markets, 
            reduce operational risks, and enhance your brand reputation by ensuring compliance with the 
            highest industry standards. With our guidance, you can streamline the certification journey 
            and confidently bring your product to market.
            </p>
            <div className="speed-optimized-wrap">
              <h4 className="title-two">Products under Compulsory Certification</h4>
              <br/>
              <p>

                <h4>BIS certification</h4>
              BIS certification scheme is basically voluntary in nature. However, for a number of products 
              compliance to Indian Standards is made compulsory by the Central Government under various 
              considerations viz. public interest, protection of human, animal or plant health, safety of 
              environment, prevention of unfair trade practices and national security. For such products, 
              the Central Government directs mandatory use of Standard Mark under a Licence or Certificate of 
              Conformity (CoC) from BIS through issuance of QCOs.
              </p>
              <br/>
              <p>The following products require compulsory certification, including but not limited to:</p>
            
              <div class="product-list">
                  <div>Agro Textiles</div>
                  <div>Air Conditioner and its related Parts</div>
                  <div>Air Cooler and Air Filters</div>
                  <div>Aluminium and Aluminium Alloy Products</div>
                  <div>Aluminium Foil</div>
                  <div>Asbestos or Fibre Cement based Products</div>
                  <div>Automobile Accessories</div>
                  <div>Automobile Wheel Rim Component</div>
                  <div>Batteries</div>
                  <div>Bolts, Nuts and Fasteners</div>
                  <div>Bottled Water Dispenser</div>
                  <div>Butterfly Valves</div>
                  <div>Capacitors</div>
                  <div>Cast Iron Products</div>
                  <div>Cattle Feeds</div>
                  <div>Cement</div>
                  <div>Centrifugally Cast Iron Pipes</div>
                  <div>Chemicals, Fertilizers, Polymers & Textiles</div>
                  <div>Cookware, Utensils and Cans</div>
                  <div>Copper Products</div>
                  <div>Cross Recessed Screws</div>
                  <div>Cycle and Rickshaw Tyres and Tubes</div>
                  <div>Cylinder, Valves and Regulator</div>
                  <div>Diesel Engines – NOx Reduction Agent AUS 32</div>
                  <div>Domestic Gas Stoves for LPG</div>
                  <div>Domestic Gas Stoves for PNG</div>
                  <div>Domestic Pressure Cooker</div>
                  <div>Domestic Water Heaters for LPG</div>
                  <div>Door Fittings</div>
                  <div>Drums and Tins</div>
                  <div>Electric Ceiling Type Fans</div>
                  <div>Electric Fence Energizers</div>
                  <div>Electric Toys</div>
                  <div>Electrical Accessories</div>
                  <div>Electrical Appliances</div>
                  <div>Electrical Appliances for Water Heating</div>
                  <div>Electrical Motors</div>
                  <div>Electrical Transformers</div>
                  <div>Feeding Bottles</div>
                  <div>Fire Extinguishers</div>
                  <div>Flame-Producing Lighters</div>
                  <div>Flat Transparent Sheet Glass</div>
                  <div>Flux Cored (Tubular) Electrodes</div>
                  <div>Flux Cored Solder Wire</div>
                  <div>Foot Wear</div>
                  <div>Geo Textiles</div>
                  <div>Gypsum based Building Materials</div>
                  <div>H Acid, K Acid & Vinyl Sulphone</div>
                  <div>Hand Tools</div>
                  <div>Helmet for Police & Personal Protection</div>
                  <div>Helmet for Two Wheeler Riders</div>
                  <div>Hinges</div>
                  <div>Household Electrical goods</div>
                  <div>Indutech</div>
                  <div>Insulated Flask, Bottles & Containers</div>
                  <div>Jute Bag</div>
                  <div>Kitchen Appliances</div>
                  <div>Laboratory Glassware</div>
                  <div>Material Measure of Length</div>
                  <div>Medical Equipment</div>
                  <div>Medical Textiles</div>
                  <div>Metals and Alloys</div>
                  <div>Miscellaneous Steel Products</div>
                  <div>Non-Electric Toys</div>
                  <div>Oil Pressure Stoves</div>
                  <div>Paper</div>
                  <div>Plugs, Sockets & AC Direct Connected Meters</div>
                  <div>Plywood and Wooden Flush Door Shutters</div>
                  <div>Poly Vinyl Chloride (PVC) Homopolymers</div>
                  <div>Polyethylene Woven Sacks</div>
                  <div>Polypropylene (PP) Materials</div>
                  <div>Potable Water Bottles</div>
                  <div>Precision Roller and Bush Chains</div>
                  <div>Press Tool-Punches</div>
                  <div>Protective Textiles</div>
                  <div>Reflectors for Bicycles</div>
                  <div>Refrigerating Appliances</div>
                  <div>Ropes and Cordages</div>
                  <div>Rubber Gaskets for Pressure Cookers</div>
                  <div>Rubber Hose for LPG</div>
                  <div>Safes, Safe Deposit Cabinets & Locks</div>
                  <div>Safety Glass</div>
                  <div>Safety of Household Electrical Appliances</div>
                  <div>Self-Contained Drinking Water Coolers</div>
                  <div>Sewing Machine</div>
                  <div>Smart Meters</div>
                  <div>Solar DC Cable & Fire Survival Cable</div>
                  <div>Solar Thermal Systems & Components</div>
                  <div>Steel and Iron Products</div>
                  <div>Steel Wires, Strands, Nylon or Wire Ropes</div>
                  <div>Telescopic Ball Bearing Drawer Slide</div>
                  <div>Transparent Float Glass</div>
                  <div>Upholstered Composites for Non-Domestic Furniture</div>
                  <div>V-Belt</div>
                  <div>Viscose Staple Fibres</div>
                  <div>Water Meters and Accessories</div>
                  <div>Water Treatment System</div>
                  <div>Welding Rods and Electrodes</div>
                  <div>Wood Based Boards</div>
                  <div>Woven Sacks</div>
            </div>
            </div>
              <div className="row">
                <div className="col-50">
                 
                    <h4 className="title-two">CE Marking</h4>
                    <p>
                    CE marking is a label that indicates a product meets the European Union's (EU) safety, health, 
                    and environmental protection standards.
                    <br/>
                    <br/>
                    <h5>What it means</h5>
                    The letters "CE" stand for Conformité Européenne, which is French for "European Conformity"
                    <br/>
                    <br/>
                    <h5>When it's required</h5>
                    CE marking is required for products manufactured anywhere in the world that are sold in the EU.
                    <br/>
                    <br/>
                   <h5> Who's responsible</h5>
                   </p>
                   <p>
                    Manufacturers are responsible for: 
                    <ul>
                      <li>Assessing the product's conformity </li>
                      <li>Setting up a technical file </li>
                      <li>Drafting and signing an EU declaration of conformity </li>
                      <li>Attaching the CE marking to the product </li>
                      
                    </ul>
                    <h5> How to obtain it</h5>

                    The process for obtaining CE marking includes: 
                    <ul>
                      <li>Identifying the applicable norms </li>
                      <li>Identifying the applicable requirements of the norms</li>
                      <li>Identifying an appropriate route to conformity </li>
                      <li>Assessing the product's conformity </li>
                      <li>Compiling the technical documentation </li>
                      <li>Making a declaration and affixing the CE marking</li>
                     </ul>                
                    </p>                  
                </div>
                
              </div>
            
            <div className="company-benefit-wrap">
              <h3>Streamlining Product Certification for Global Market Access</h3>
              <p>
              Our consultants are experts in the certification process, bringing a wealth of 
              knowledge across multiple industries. We handle the complexities of product certification 
              so that you can focus on what matters most—growing your business. Our comprehensive 
              services are designed to streamline the process, ensuring that your product is market-ready
               and fully compliant with industry standards.
              <br/>
              <br/>
              Let us guide you through the certification journey, ensuring that your product is 
              recognized, trusted, and compliant in every market you enter. 

        <Link to = "/contact">Contact us</Link> to know more.


                         </p>

              {/* faq */}
              </div>
          </div>
        </div>
      </ServicesDetailsWrapper>

      {/* brand-area */}
      <BrandSeven />
    </Layout>
  );
};

export default ServicesDetailsPageFive;
